/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 3/31/2022.
 */

import {apiUrl, composeCommonQuery, getEnumParams, handleApiCall, securedApiOptions} from './HttpUtils'
import {composeFaultQuery} from './Faults'

const getAirtimeApiUrl = () => {
    return apiUrl(`airtime`)
}

export const goToAirtimeUrl = (sessionId) => {
    const opts = securedApiOptions()
    opts.method = 'POST'
    return handleApiCall(getAirtimeApiUrl() + '/process?sessionId=' + sessionId, opts)
}

export const createAsset = (sessionId, asset) => {
    const opts = securedApiOptions()
    opts.method = 'POST'
    opts.body = JSON.stringify(asset)
    return handleApiCall(getAirtimeApiUrl() + '/createAsset?sessionId=' + sessionId, opts)
}

export const reportSymptoms = (sessionId) => {
    const opts = securedApiOptions()
    opts.method = 'POST'
    return handleApiCall(getAirtimeApiUrl() + '/reportSymptoms?sessionId=' + sessionId, opts)
}

export const fetchAssets = (search, sort, sortOrder) => {
    const sessionId = localStorage.getItem("sessionId")
    return handleApiCall(getAirtimeApiUrl() + '/assets' + composeCommonQuery(search, sort, sortOrder) + '&sessionId=' + sessionId)
}

export const fetchAsset = () => {
    const sessionId = localStorage.getItem("sessionId")
    return handleApiCall(getAirtimeApiUrl() + '/asset?sessionId=' + sessionId)
}

export const submitAssetObservations = (assetId, observations) => {
    const sessionId = localStorage.getItem("sessionId")
    const opts = securedApiOptions()
    opts.method = 'PUT'
    opts.body = JSON.stringify(observations)
    return handleApiCall(getAirtimeApiUrl() + '/asset/observations?sessionId=' + sessionId, opts)
}

export const fetchAssetObservation = (assetId, states, types) => {
    const sessionId = localStorage.getItem("sessionId")
    return handleApiCall(getAirtimeApiUrl() + '/asset/observations?sessionId=' + sessionId + '&createFault=true' + getEnumParams('states', states) + getEnumParams('symptomTypes', types))
}

export const fetchAssetFaultsWithoutPagination = (assetId, states, search, filterObj, sort, ids, assignees) => {
    return fetchAssetFaults(assetId, states, search, filterObj, sort, ids, assignees)
}

export const fetchAssetFaults = (assetId, states, search, filterObj, sort, ids, assignees) => {
    const sessionId = localStorage.getItem("sessionId")
    return handleApiCall(getAirtimeApiUrl() + `/asset/faults` + composeFaultQuery(states, search, filterObj, sort, ids, assignees) + '&sessionId=' + sessionId)
}

/**
 * Fetch all faults which can current user sees based on filter conditions
 * @param states
 * @param search
 * @param sort
 * @param ids
 * @returns {*}
 */
export const fetchFaultsWithoutPagination = (states, search, sort, ids, assignee) => {
    const filterObj = {
        search: search,
        sort: sort,
    }
    return fetchFaults(states, filterObj, ids, assignee)
}

/**
 * Fetch all faults with pagination parameters
 * @param states
 * @param filterObj contains search, start, limit, sort values
 * @param ids
 * @returns {*}
 */
export const fetchFaults = (states, filterObj, ids, assignee) => {
    const sessionId = localStorage.getItem("sessionId")
    return handleApiCall(getAirtimeApiUrl() + '/asset/faults' + composeFaultQuery(states, filterObj, ids, assignee) + '&sessionId=' + sessionId)
}

export const fetchObservations = (assetId, faultId, types = [], states = []) => {
    const sessionId = localStorage.getItem("sessionId")
    let query = '?start=0';
    query += getEnumParams('symptomTypes', types)
    query += getEnumParams('states', states)
    return handleApiCall(getAirtimeApiUrl() + `/asset/faults/${faultId}/observations` + query + '&sessionId=' + sessionId)
}

export const submitObservations = (assetId, faultId, observations) => {
    const sessionId = localStorage.getItem("sessionId")
    const opts = securedApiOptions()
    opts.method = 'PUT'
    opts.body = JSON.stringify(observations)
    return handleApiCall(getAirtimeApiUrl() + `/asset/faults/${faultId}/observations?sessionId=` + sessionId, opts)
}

export const fetchActions = (assetId, faultId) => {
    const sessionId = localStorage.getItem("sessionId")
    return handleApiCall(getAirtimeApiUrl() + `/asset/faults/${faultId}/actions?sessionId=` + sessionId)
}

export const fetchActionDetail = (assetId, actionId, faultId, actionType) => {
    const sessionId = localStorage.getItem("sessionId")
    let query = '?type=' + actionType + '&sessionId=' + sessionId
    if (faultId) {
        query += '&fault=' + faultId
    }
    return handleApiCall(getAirtimeApiUrl() + `/asset/action/${actionId}` + query)
}

export const submitTestResult = (assetId, faultId, testId, testValue, learningLoopTest, learningLoopTestResult) => {
    const sessionId = localStorage.getItem("sessionId")
    const opts = securedApiOptions()
    opts.method = 'PUT'
    opts.body = JSON.stringify(testValue)
    const query = `?sessionId=${sessionId}&learningLoopTest=${learningLoopTest}&learningLoopTestResult=${learningLoopTestResult}`
    return handleApiCall(getAirtimeApiUrl() + `/asset/faults/${faultId}/tests/${testId}` + query, opts)
}

export const fetchTestResultsForTest = (assetId, faultId, testId) => {
    const sessionId = localStorage.getItem("sessionId")
    const opts = securedApiOptions()
    opts.method = 'GET'
    const query = `?sessionId=${sessionId}`
    return handleApiCall(getAirtimeApiUrl() + `/asset/faults/${faultId}/tests/${testId}` + query, opts)
}

export const createNewTestResult = (assetId, testId, testResultName, learningLoopTest) => {
    const sessionId = localStorage.getItem("sessionId")
    const opts = securedApiOptions()
    opts.method = 'PUT'
    const query = `?sessionId=${sessionId}&testId=${testId}&testResultName=${testResultName}&learningLoopTest=${learningLoopTest}`
    return handleApiCall(getAirtimeApiUrl() + "/asset/createNewTestResult/" + query, opts)
}

export const createNewTest = (assetId, faultId, testName) => {
    const sessionId = localStorage.getItem("sessionId")
    const opts = securedApiOptions()
    opts.method = 'PUT'
    const query = `?sessionId=${sessionId}&testName=${testName}`
    return handleApiCall(getAirtimeApiUrl() + `/asset/faults/${faultId}/createNewTest/` + query, opts)
}

export const deleteTestResult = (assetId, faultId, testResultId) => {
    const sessionId = localStorage.getItem("sessionId")
    const opts = securedApiOptions()
    opts.method = 'DELETE'
    const query = `?sessionId=${sessionId}`
    return handleApiCall(getAirtimeApiUrl() + `/asset/faults/${faultId}/deleteTestResult/${testResultId}` + query, opts)
}

export const deleteTest = (assetId, faultId, testId) => {
    const sessionId = localStorage.getItem("sessionId")
    const opts = securedApiOptions()
    opts.method = 'DELETE'
    const query = `?sessionId=${sessionId}`
    return handleApiCall(getAirtimeApiUrl() + `/asset/faults/${faultId}/deleteTest/${testId}` + query, opts)
}

export const submitCorrectiveActionResult = (assetId, faultId, actionId, actionValue) => {
    const sessionId = localStorage.getItem("sessionId")
    const opts = securedApiOptions()
    opts.method = 'PUT'
    opts.body = actionValue.toString()
    return handleApiCall(getAirtimeApiUrl() + `/asset/faults/${faultId}/actions/${actionId}?sessionId=` + sessionId, opts)
}

export const saveComment = (assetId, faultId, comment) => {
    const sessionId = localStorage.getItem("sessionId")
    const opts = securedApiOptions()
    opts.method = 'POST'
    opts.body = comment
    return handleApiCall(getAirtimeApiUrl() + `/asset/faults/${faultId}/comments?sessionId=` + sessionId, opts)
}

export const updateComment = (assetId, faultId, commentId, comment) => {
    const sessionId = localStorage.getItem("sessionId")
    const opts = securedApiOptions()
    opts.method = 'PUT'
    opts.body = comment
    return handleApiCall(getAirtimeApiUrl() + `/asset/faults/${faultId}/comments/${commentId}?sessionId=` + sessionId, opts)
}

export const fetchActionLog = (assetId, faultId, primaryFaultId, actionTypes, objectTypes) => {
    const sessionId = localStorage.getItem("sessionId")
    let query = '?start=0';
    if (faultId) {
        query += '&faultId=' + faultId
    }
    if (primaryFaultId) {
        query += '&primaryFaultId=' + primaryFaultId
    }
    query += getEnumParams('actionTypes', actionTypes)
    query += getEnumParams('objectTypes', objectTypes)
    return handleApiCall(getAirtimeApiUrl() + '/asset/log' + query + '&sessionId=' + sessionId)
}

export const fetchComments = (assetId, faultId) => {
    const sessionId = localStorage.getItem("sessionId")
    return handleApiCall(getAirtimeApiUrl() + `/asset/faults/${faultId}/comments?sessionId=` + sessionId)
}

export const fetchDetails = (assetId, faultId) => {
    const sessionId = localStorage.getItem("sessionId")
    return handleApiCall(getAirtimeApiUrl() + `/asset/faults/${faultId}?sessionId=` + sessionId)
}

export const submitConfigSymptom = (assetId, faultId, id, value) => {
    const sessionId = localStorage.getItem("sessionId")
    const symptoms = [{id: id, state: value, description: ''}]
    const opts = securedApiOptions()
    opts.method = 'PUT'
    opts.body = JSON.stringify(symptoms)
    return handleApiCall(getAirtimeApiUrl() + `/asset/faults/${faultId}/configurationSymptoms?sessionId=` + sessionId, opts)
}

export const setFaultState = (assetId, faultId, state, observations, comment = null) => {
    const sessionId = localStorage.getItem("sessionId")
    const opts = securedApiOptions()
    opts.method = 'PUT'
    opts.body = JSON.stringify({
        state: state,
        observations: observations,
        comment: comment,
    })
    return handleApiCall(getAirtimeApiUrl() + `/asset/faults/${faultId}/state?sessionId=` + sessionId, opts)
}

export const fetchDwp = (assetId, faultId) => {
    const sessionId = localStorage.getItem("sessionId")
    const opts = securedApiOptions()
    opts.method = 'GET'
    return handleApiCall(getAirtimeApiUrl() + `/asset/faults/${faultId}/dwp?sessionId=` + sessionId, opts)
}

export const fetchTechPubDocument = (assetId, techPubId) => {
    const sessionId = localStorage.getItem("sessionId")
    return handleApiCall(getAirtimeApiUrl() + `/asset/techpub/${techPubId}?sessionId=` + sessionId)
}

export const fetchAllNamesExceptAllocated = (assetId, faultId, type) => {
    const sessionId = localStorage.getItem("sessionId")
    const opts = securedApiOptions()
    opts.method = 'GET'
    const query = `?sessionId=${sessionId}&type=${type}`
    return handleApiCall(getAirtimeApiUrl() + `/asset/faults/${faultId}/otherNames` + query, opts)
}

export const assignUser = (assetId, faultId, userIds) => {
    const sessionId = localStorage.getItem("sessionId")
    const opts = securedApiOptions()
    opts.method = 'PUT'
    opts.body = JSON.stringify(userIds)
    return handleApiCall(getAirtimeApiUrl() + `/asset/faults/${faultId}/assignee?sessionId=` + sessionId, opts)
}

export const AirtimeExceptions = {
    UNIQUE_SESSION_INVALID: 'business.exception.UNIQUE_SESSION_INVALID',
    UNIQUE_SESSION_EXPIRED: 'business.exception.UNIQUE_SESSION_EXPIRED',
    UNIQUE_SESSION_USER_UNAUTHORIZED: 'business.exception.UNIQUE_SESSION_USER_UNATHORIZED',
}

export const reexportLearningLoopPacket = (faultId) => {
    const sessionId = localStorage.getItem("sessionId")
    const opts = securedApiOptions()
    opts.method = 'GET'
    return handleApiCall(getAirtimeApiUrl() + `/asset/faults/${faultId}/resynchronize?sessionId=` + sessionId + '&faultId=' + faultId, opts)
}
